import UnionsContainer from './unions_container';

const Unions = UnionsContainer;
export default Unions;
